<template>
  <time class="current-date-time" :datetime="isoDateTime" :title="fullDateTime">
    <i class="fa-regular fa-clock" aria-hidden="true"></i>
    <span>{{ shortDateTime }}</span>
  </time>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CurrentDateTime',
  data() {
    return {
      now: new Date(),
      timerId: null,
    };
  },
  computed: {
    isoDateTime() {
      return this.now.toISOString();
    },
    shortDateTime() {
      return new Intl.DateTimeFormat('fr-FR', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
      }).format(this.now);
    },
    fullDateTime() {
      return new Intl.DateTimeFormat('fr-FR', {
        dateStyle: 'full',
        timeStyle: 'medium',
      }).format(this.now);
    },
  },
  mounted() {
    this.timerId = window.setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
  beforeUnmount() {
    if (this.timerId) {
      window.clearInterval(this.timerId);
    }
  },
});
</script>

<style scoped>
.current-date-time {
  align-items: center;
  /* border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px; */
  color: rgba(255, 255, 255, 0.86);
  display: inline-flex;
  font-size: 0.76rem;
  font-weight: 800;
  gap: 0.45rem;
  line-height: 1;
  min-height: 32px;
  padding: 0 0.72rem;
  white-space: nowrap;
}

.current-date-time i {
  font-size: 0.84rem;
}

@media (max-width: 575.98px) {
  .current-date-time {
    justify-content: center;
    width: 100%;
  }
}
</style>
